import React from 'react';

import {convertParamsForVersionsQuery} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/utils';
import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {useInfiniteListFetcherRTK} from 'app/general/datafetchers/hooks/useInfiniteListFetcherRTK';
import {useProcedureVersions} from 'app/procedures/api';

import type {LeftSidebarPanelType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  ProcedureHashidSerializedType,
  ProcedureVersionSerializedType,
} from 'sweet-types';

const VersionsSidebarComponent =
  VersionsSidebarFactory<ProcedureVersionSerializedType>();
export function ProcedureVersionsPanelContent({
  object,
  version,
}: LeftSidebarPanelType<ProcedureHashidSerializedType>) {
  const {
    results: versions,
    refetch,
    loadNext,
    hasNext,
  } = useInfiniteListFetcherRTK({
    fetchParams: {
      objectId: object.id,
    },
    useDataHook: useProcedureVersions,
    paramsConverter: convertParamsForVersionsQuery,
  });
  return (
    <VersionsSidebarComponent
      object={object}
      selectedVersion={version}
      loadVersions={async () => refetch()}
      loadMoreVersions={async () => loadNext()}
      moreToLoad={hasNext}
      versions={versions}
    />
  );
}
